import React from 'react';

import BeerList from '../components/CoalList/BeerList';

const BeerPuller: React.FC = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-12">
          <BeerList />
        </div>
      </div>
    </div>
  );
};

export default BeerPuller;
